/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// Dependencias
import React, { Component } from 'react';
import ScrollUtils from '../../Utils/Scroll';

// Hojas de Estilos
import './Index.scss';

const ListAccordionItem = ({ itemOnClick, item, selected }) => (
  <div className="list-collapse__item">
    <a className="item__button" onClick={itemOnClick} role="button" tabIndex={0}>
      <p className="text-uppercase">{item.text}</p>
      <div className={selected === true ? 'button__icon active' : 'button__icon'}>
        <span className="icon-sort-up"><i className="fas fa-sort-up" /></span>
        <span className="icon-sort-down"><i className="fas fa-sort-down" /></span>
      </div>
    </a>
    <div className={selected === true ? 'item__content active' : 'item__content'}>
      {item.data}
    </div>
  </div>
);

class ListAccordion extends Component {
  static initScroll(selectedItemIndex, listIndex = 0) {
    const startY = ScrollUtils.getCurrentYPosition();
    const stopY = ScrollUtils.getElementYPosition(document.getElementsByClassName('list-collapse')[listIndex].getElementsByClassName('list-collapse__item')[selectedItemIndex]);
    const distance = stopY > startY ? stopY - startY : startY - stopY;
    let finalStop = stopY > startY ? startY + distance : startY - distance;
    finalStop -= 130;
    ScrollUtils.scroll(startY, finalStop);
  }

  constructor(props) {
    super(props);

    this.state = {
      selectedItemIndex: props.indexSelected,
    };

    this.itemOnClick.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.indexSelected !== prevState.selectedItemIndex) {
      return {
        selectedItemIndex: nextProps.indexSelected,
      };
    }
    return null;
  }

  componentDidUpdate() {
    const { indexSelected, listIndex } = this.props;
    ListAccordion.initScroll(indexSelected, listIndex);
  }

  itemOnClick(e, selectedItemIndex) {
    const { callBackClick } = this.props;
    const { selectedItemIndex: stateSelectedItemIndex } = this.state;
    e.preventDefault();
    const active = stateSelectedItemIndex === selectedItemIndex;

    if (!active) {
      this.setState({
        selectedItemIndex,
      });
      if (callBackClick !== undefined) {
        callBackClick(e, selectedItemIndex);
      }
    }
  }

  render() {
    const { items, indexSelected, listIndex } = this.props;
    const { selectedItemIndex } = this.state;
    return (
      <div className="list-collapse">
        {
                    items.map((item, index) => {
                      let active = selectedItemIndex === index;

                      if (indexSelected !== undefined) {
                        active = indexSelected === index;
                      }

                      return (
                        <ListAccordionItem item={item} selected={active} itemOnClick={e => this.itemOnClick(e, index, listIndex)} key={index} />
                      );
                    })
                }
      </div>
    );
  }
}

export default ListAccordion;
